import { connect } from "react-redux";
import DocumentEditorProps from "./documentEditorPanel";
import actionCreators from "./redux/actionCreators";
import { getData, getDocumentId, getInProgress, getMode } from "./redux/selectors";
const mapStateToProps = (state) => ({
    mode: getMode(state),
    data: getData(state),
    documentId: getDocumentId(state),
    inProgress: getInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (documentId) => dispatch(actionCreators.getDocument(documentId)),
    onClose: () => dispatch(actionCreators.closeForm())
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentEditorProps);
